var _defs, _path, _path2, _polygon, _path3, _polygon2, _path4, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTcmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.44 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.39,6.17c-15.91,0-28.8,12.9-28.8,28.8,0,6.87,2.41,13.18,6.43,18.13l-6.43,10.67,11.7-5.63c4.78,3.54,10.7,5.63,17.1,5.63,15.91,0,28.8-12.9,28.8-28.8s-12.9-28.8-28.8-28.8M131.26,44.1c-5.04,2.14-10.87-.21-13.01-5.26-2.14-5.04.21-10.87,5.26-13.01,5.04-2.14,10.87.21,13.01,5.26,2.14,5.04-.21,10.87-5.26,13.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.33,50.75v-.07c0-7.36,5.55-13.39,13.5-13.39,4.88,0,7.8,1.63,10.21,3.99l-3.62,4.18c-2-1.81-4.03-2.92-6.62-2.92-4.36,0-7.51,3.62-7.51,8.06v.07c0,4.44,3.07,8.14,7.51,8.14,2.96,0,4.77-1.18,6.8-3.03l3.62,3.66c-2.66,2.85-5.62,4.62-10.61,4.62-7.62,0-13.28-5.88-13.28-13.31"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.98 37.73 42.12 37.73 48.92 48.68 55.72 37.73 61.86 37.73 61.86 63.62 56.21 63.62 56.21 46.72 48.92 57.78 48.77 57.78 41.56 46.83 41.56 63.62 35.98 63.62 35.98 37.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.9,50.75v-.07c0-7.36,5.8-13.39,13.79-13.39s13.72,5.95,13.72,13.31v.07c0,7.36-5.81,13.39-13.79,13.39s-13.72-5.95-13.72-13.31M85.46,50.75v-.07c0-4.44-3.25-8.13-7.84-8.13s-7.77,3.62-7.77,8.06v.07c0,4.44,3.26,8.14,7.84,8.14s7.77-3.62,7.77-8.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.09 7.82 10.75 7.82 10.75 6.18 29.21 6.18 29.21 7.82 20.87 7.82 20.87 30.11 19.09 30.11 19.09 7.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.19,6.18h1.71l11.14,23.92h-1.95l-3.04-6.65h-14.12l-3.04,6.65h-1.85l11.14-23.92ZM45.3,21.86l-6.29-13.74-6.32,13.74h12.61Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.55 6.18 56.33 6.18 56.33 28.47 70.38 28.47 70.38 30.11 54.55 30.11 54.55 6.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.96 6.18 88.28 6.18 76.13 17.44 76.13 6.18 74.35 6.18 74.35 30.11 76.13 30.11 76.13 18.85 88.28 30.11 90.96 30.11 78.06 18.14 90.96 6.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTcmo);
export default __webpack_public_path__ + "static/media/White TCMO.421b83a5520d312ede8ba5b87da91bd8.svg";
export { ForwardRef as ReactComponent };